import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {useIntl} from "react-intl";
import {Col, Form, Input, message, Row, Space, Typography} from "antd";
import dayjs from 'dayjs';
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import customParseFormat from "dayjs/plugin/customParseFormat";

import AtomicPopup from "src/components/AtomicPopup";

import beApis from "src/util/apis/be";
import IntlMessages from "src/util/IntlMessages";
import AtomicButton from 'src/components/AtomicButton';
import {usePopup} from "src/util/use-popup";
import AllowedDeviceSelectionItem from "../../components/AllowedDeviceSelectionItem";
import {convertDateFormat} from "../../util/common";
import ToastSuccess from "../../assets/svg/ToastSuccess";

const {Text} = Typography;
const { TextArea } = Input;

const styles = {
  content: {flex: 1},
  infoSection: {
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: 4,
    padding: '20px 34px',
    // marginBottom: 20,
    gap: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  infoRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  bulletIcon: {
    display: 'inline-block',
    width: 5,
    height: 5,
    borderRadius: '50%',
    background: '#000',
    marginRight: 10,
  },
  label: {
    fontSize: 16,
    fontWeight: 700,
    marginRight: 8,
    color: '#222',
  },
  infoValue: {
    fontSize: 14,
    color: '#181818',
    flex: 1,
    display: 'inline-block',
    maxWidth: '70%',
    verticalAlign: 'middle'
  },
};

function InfoRow({labelId, children}) {
  return (
    <div style={styles.infoRow}>
      <span style={styles.bulletIcon}/>
      <Text style={styles.label}>
        <IntlMessages id={labelId}/>:
      </Text>
      <Text ellipsis={{rows: 1, tooltip: true}} style={styles.infoValue}>{children}</Text>
    </div>
  );
}

const AccessModePopup = ({selectedAllowedDevice, isMessageMode, onOk, onCancel, refreshData}) => {

  const csSelected = useSelector(({cs}) => cs.csSelected);
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [form] = Form.useForm();
  const {confirmPopup, infoPopup} = usePopup();

  const [sessionTime, setSessionTime] = useState();
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const [useAccessTime, setUseAccessTime] = useState(true);
  const [useSessionTime, setUseSessionTime] = useState(true);
  const [selectedOption, setSelectedOption] = useState(selectedAllowedDevice?.expires_at ? 'temporary' : 'trust');

  const deviceName = selectedAllowedDevice?.os?.split(' ')[0] || intl.formatMessage({id: 'vlink.login.device.unknown'});
  const deviceIp = selectedAllowedDevice?.ip || intl.formatMessage({id: 'vlink.login.device.unknown'});
  const deviceLocation = selectedAllowedDevice?.geo_data?.city || intl.formatMessage({id: 'vlink.login.device.unknown'});
  const timeValue = selectedAllowedDevice?.approved_at || selectedAllowedDevice?.geo_data?.connected_at;
  const deviceRegisterTime = timeValue ? convertDateFormat(timeValue) : '';
  const requestMessage = selectedAllowedDevice?.message || ''

  dayjs.extend(weekday);
  dayjs.extend(localeData);
  dayjs.extend(customParseFormat);

  useEffect(() => {
    if (isMessageMode) {
      handleMessageRead();
    }
  }, []);

  const handleUpdate = () => {
    const req = {
      need_to_limit: selectedOption === 'temporary',
    }
    beApis.updateAllowedDevice(csSelected.host, selectedAllowedDevice.id, req).then((resp) => {
      message.success({
        content: intl.formatMessage({id: 'vlink.common.updated'}),
        icon: <ToastSuccess/>,
      });
      onOk && onOk();
      // infoPopup(intl.formatMessage({id: "vlink.common.updated"}), () => onOk())
    })
  }

  const handleMessageRead = () => {
    const req = {
      message_read: true,
    }
    beApis.updateAllowedDevice(csSelected.host, selectedAllowedDevice.id, req).then((resp) => {
      refreshData && refreshData();
      // infoPopup(intl.formatMessage({id: "vlink.common.updated"}), () => onOk())
    })
  }

  return <AtomicPopup
    title={
      <span>
        <IntlMessages id="vlink.settings.access.editDeviceInfo"/>
      </span>
    }
    open={true}
    onOk={() => {
      onOk && onOk();
    }}
    onCancel={() => {
      onCancel && onCancel()
    }}
    centered
    footer={<div style={{
      height: 1,
    }}></div>}
    width={635}
  >
    <div style={{padding: "16px 0 12px 0"}}>
      <Space direction="vertical" size={12} style={{width: '100%'}}>
        <Row>
          <div style={styles.content}>
            {/* 기기 정보 */}
            <div style={styles.infoSection}>
              <div style={{display: 'flex', width: '100%'}}>
                <Space direction="vertical" size={8} style={{width: '100%'}}>
                  <InfoRow labelId="vlink.settings.access.client">
                    {deviceName}
                  </InfoRow>
                  {/*<InfoRow labelId="vlink.login.device.location">*/}
                  {/*  {deviceLocation}*/}
                  {/*</InfoRow>*/}
                </Space>
                <Space direction="vertical" size={8} style={{width: '100%'}}>
                  <InfoRow labelId="vlink.common.ip">
                    {deviceIp}
                  </InfoRow>

                  <InfoRow labelId="vlink.settings.access.registerTime">
                    {deviceRegisterTime}
                  </InfoRow>
                </Space>
              </div>
            </div>
          </div>
        </Row>
        {isMessageMode ?
          <Row>
            <div style={styles.content}>
              <TextArea
                value={requestMessage}
                style={{
                  width: '100%',
                  fontSize: 14,
                  color: '#444',
                  borderRadius: 4,
                  // border: '1px solid #B9B9B9',
                  padding: '20px 20px',
                  // boxSizing: 'border-box',
                  background: '#EBF5FF',
                  marginBottom: 8,
                  resize: 'none',
                }}
                rows={6}
                disabled={true}
              />

            </div>
          </Row>:
        <Row gutter={8}>
          <Col span={12}>
            <AllowedDeviceSelectionItem
              title={<IntlMessages id="vlink.settings.access.unlimitedAllow"/>}
              message={<IntlMessages id='vlink.settings.access.continuous'/>}
              active={selectedOption === 'trust'}
              onClick={() => setSelectedOption('trust')}
            />
          </Col>
          <Col span={12}>
            <AllowedDeviceSelectionItem
              title={<IntlMessages id="vlink.settings.access.limited"/>}
              message={<IntlMessages id='vlink.settings.access.blockAfter24h'/>}
              active={selectedOption === 'temporary'}
              onClick={() => setSelectedOption('temporary')}
            />
          </Col>
        </Row>}
      </Space>

      <Row style={{justifyContent: "flex-end", marginTop: 20}} className="popup-button-row">
        {isMessageMode ?
          <AtomicButton onClick={() => onOk?.()} label={intl.formatMessage({id: "vlink.common.ok"})} type="primary"/> :
        <Space>
          <AtomicButton onClick={onCancel} label={intl.formatMessage({id: "vlink.button.cancel"})} type="default"/>
          <AtomicButton onClick={handleUpdate} label={intl.formatMessage({id: "vlink.button.save"})} type="primary"/>
        </Space>
        }
      </Row>
    </div>


  </AtomicPopup>
}

export default AccessModePopup;
